
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/tiktok",
      function () {
        return require("private-next-pages/destinations/tiktok.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/tiktok"])
      });
    }
  